export default __webpack_public_path__ + "static/media/carrito.2f54ef53.svg";